import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function menuModel() {
  const fetchGetMenuList = reactive({
    api: apiEndpoint.bcrm_platform + "/menu/List",
    method: "GET",
    payload: {
      Brand_Ref: null,
    },
  });

  return {
    fetchGetMenuList,
  };
}
